"use strict";exports.stringToUint8Array=function(r){return new Uint8Array(r.split("").map((function(r){return r.charCodeAt(0)})))};
//# sourceMappingURL=stringToUint8Array.cjs.map
